<template>
  <fragment>
    <b-row>
      <b-col>
        <Heading1 text="List of users">
          <b-button size="sm" variant="light" @click="fetchListUser">
            <b-icon-arrow-repeat />
          </b-button>
          <CreateUserForm @onSubmit="createUser" />
        </Heading1>

        <b-table striped hover :fields="reviewSessionFields" :items="listUser" responsive="sm">
          <template v-slot:cell(type)="data">
            <b-badge variant="info">
              {{ data.value }}
            </b-badge>
          </template>

          <template v-slot:cell(creator)="data">
            <span class="small">{{ data.value.name }}</span>
          </template>

          <template v-slot:cell(updater)="data">
            <span class="small">{{ data.value.name }}</span>
          </template>

          <template v-slot:cell(updatedAt)="data">
            <span class="small">{{ fmtDate(data.value) }}</span>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CreateUserForm from '../components/CreateUserForm';
import api from '../api';
import { baseFields, userFragment } from '../fragments';
import Heading1 from '@/components/Heading1';

export default {
  name: 'ManagingUser',
  components: { CreateUserForm, Heading1 },
  data() {
    return {
      reviewSessionFields: [
        'name',
        'type',
        'creator',
        'updater',
        {
          key: 'updatedAt',
          label: 'Last update',
        },
      ],
    };
  },
  methods: {
    ...mapActions('user', ['fetchListUser']),
    createUser(formData) {
      api
        .gql({
          query: `mutation createUser($input: createUserInput!) {
            createUser(input: $input) {
              out {
                ${baseFields}
                name
                type
              }
            }
          }`,
          variables: {
            input: {
              name: formData.name,
              type: formData.type,
            },
          },
          fragments: [userFragment],
        })
        .then(({ createUser: { out } }) => {
          this.$toastr.s(JSON.stringify(out, null, 2), 'Created User');
        });
    },
  },
  computed: {
    ...mapGetters('user', ['listUser']),
  },
  mounted() {
    this.fetchListUser();
  },
};
</script>
